import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { gql, useQuery } from '@apollo/client'
import { useTranslation } from 'react-i18next'
import { Row, Select, Popover } from 'antd'
import { InfoCircleTwoTone } from '@ant-design/icons'
import CentredLoader from 'components/CentredLoader'
import { AddressType, CountryConfigType } from '../../../../types/index'

const ADDRESSES = gql`
  query getAddresses($countryConfigId: ID!) {
    addresses(countryConfigId: $countryConfigId) {
      id
      fullAddress
      shortname
      pickupInstructions
      postalCode
      scanecoManaged
    }
  }
`

interface Props {
  field: any
  form: any
  countryConfig: CountryConfigType
  setEstimationVariables: any
  estimationVariables: any
  readOnlyForm: boolean
}

const Addresses = (props: Props): JSX.Element => {
  const { t } = useTranslation()
  const { loading, data } = useQuery(ADDRESSES, {
    variables: { countryConfigId: props.countryConfig.id },
  })
  const [selectedAddressId, setSelectedAddressId] = useState(props.field.value)

  useEffect(() => {
    if (selectedAddressId !== props.estimationVariables.addressId) {
      props.form.setFieldValue(props.field.name, selectedAddressId)
      props.setEstimationVariables({
        ...props.estimationVariables,
        addressId: selectedAddressId,
      })
    }
  }, [selectedAddressId])

  if (loading) return <CentredLoader />

  const { addresses } = data
  const selectedAddress = addresses.find((a: AddressType) => {
    if (a.id === selectedAddressId) return a
  })

  return (
    <Wrapper>
      <Row>
        <label>{t('address.label')}</label>
        <Popover
          title={selectedAddress?.fullAddress}
          content={() => {
            return (
              <div>
                <div
                  dangerouslySetInnerHTML={{
                    __html: selectedAddress?.pickupInstructions,
                  }}
                />
                {selectedAddress && (
                  <span>
                    {selectedAddress.scanecoManaged
                      ? "Le courrier n'est pas disponible sur le centre."
                      : 'Le courrier est disponible sur le centre.'}
                  </span>
                )}
              </div>
            )
          }}
          placement="bottomLeft"
        >
          <InfoCircleTwoTone twoToneColor="#1576E1" />
        </Popover>
      </Row>
      <Row>
        <Select
          disabled={props.readOnlyForm}
          showSearch
          defaultValue={props.field.value}
          onChange={setSelectedAddressId}
          style={{ width: '250px' }}
          filterOption={(input, option) =>
            (option!.children as unknown as string)
              .toLowerCase()
              .includes(input.toLowerCase())
          }
        >
          {addresses.map((item: AddressType) => {
            return (
              <Select.Option key={item.id} value={item.id}>
                {`${item.postalCode} ${item.shortname}`}
              </Select.Option>
            )
          })}
        </Select>
      </Row>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  label {
    margin-right: 5px;
  }
`

export default Addresses
